import { QueryClient, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Pagination, TaxPaymentSlip } from '@/types'

export type ListTaxPaymentSlipsParams = {
  company_key: string
  due_month?: number
  due_year?: number
  month?: number
  page?: number
  page_size?: number
  paid?: boolean
  year?: number
}

export async function listTaxPaymentSlips({
  company_key,
  ...params
}: ListTaxPaymentSlipsParams) {
  const response = await httpClient('accounting-dealer').get<
    Pagination<TaxPaymentSlip>
  >(`/v3/company/${company_key}/tax-payment-slips`, {
    params,
  })

  return response.data
}

export const TAX_PAYMENT_SLIPS_QUERY_KEY = ['tax-payment-slips'] as const

export function invalidateTaxPaymentSlipsQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: TAX_PAYMENT_SLIPS_QUERY_KEY })
}

export function useListTaxPaymentSlips(
  params: ListTaxPaymentSlipsParams,
  options?: Partial<UseQueryOptions<Pagination<TaxPaymentSlip>>>,
) {
  return useQuery({
    queryKey: [...TAX_PAYMENT_SLIPS_QUERY_KEY, params],
    queryFn: () => listTaxPaymentSlips(params),
    enabled: Boolean(params.company_key),
    ...options,
  })
}
